import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import { RegularSection } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'
import { resolveHref } from '@/utilites/resolveHref'
import { Box } from '@mui/material'

interface ButtonData {
    text?: string
    link?: string
}

interface Card {
    image?: string | Record<string, unknown>
    title?: string
    description?: string
    bullet1?: string
    bullet2?: string
    bullet3?: string
    button?: ButtonData
}

interface Content {
    cards?: Card[]
}

interface S1_L2_3Props {
    content?: Content
    blockName?:string
}

interface BulletTextProps {
    text?: string
}

const BulletText = (props: BulletTextProps) => {
    const { text } = props
    return (
        <Typography
            variant='h3'
            color='secondary'
            sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
        >
            <CheckBoxIcon />
            {text}
        </Typography>
    )
}

interface CardItemProps {
    image?: string
    title?: string
    description?: string
    bullet1?: string
    bullet2?: string
    bullet3?: string
    button?: ButtonData
    index: number
}

const CardItem = (props: CardItemProps) => {
    const { image, title, description, bullet1, bullet2, bullet3, button = {}, index } = props
    const buttonHref = resolveHref(button.link, '#')
    const isEven = index % 2 === 1
    return (
        <Grid
            container
            spacing={4}
            direction={isEven ? 'row-reverse' : 'row'}
        >
            <Grid
                size={{ xs: 12, md: 6, lg: 4 }}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    justifyContent: 'center',
                    borderRadius: 5,
                    backgroundColor: '#212121',
                    p: 4,
                }}
            >
                <Typography
                    variant='h2'
                    color='secondary'
                >
                    {title}
                </Typography>
                <Typography
                    variant='body1'
                    color='secondary'
                >
                    {description}
                </Typography>
                <BulletText text={bullet1} />
                <BulletText text={bullet2} />
                <BulletText text={bullet3} />
                <Button
                    variant='contained'
                    size='large'
                    href={buttonHref}
                    sx={{ width: 'fit-content' }}
                >
                    {button.text}
                </Button>
            </Grid>
            <Grid
                size={{ xs: 12, md: 6, lg: 8 }}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundImage: `url(${image})`,
                    backgroundSize: 'cover',
                    borderRadius: 5,
                    minHeight: { xs: 300, md: 'auto' },
                }}
            />
        </Grid>
    )
}

const Index = (props: S1_L2_3Props) => {
    const { content = {} } = props
    const { cards = [] } = content
    const normalizedCards = cards.map((card) => {
        const { src } = getImageData(card.image)
        return {
            ...card,
            image: src,
        }
    })
    return (
        <RegularSection aria-label='S1_L2_3' >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4, width: '100%' }}>
                {normalizedCards.map((card, index) => (
                    <CardItem
                        key={'S1_L2_3' + index}
                        image={card.image}
                        title={card.title}
                        description={card.description}
                        bullet1={card.bullet1}
                        bullet2={card.bullet2}
                        bullet3={card.bullet3}
                        button={card.button}
                        index={index}
                    />
                ))}
            </Box>
        </RegularSection>
    )
}

export default Index
